import { useEffect, useState } from "react";

import { useShallow } from "zustand/react/shallow";

import { daysOfTheWeek } from "@/constants/calendar";
import { fetchVehicleReservationsByDate } from "@/apis/reservation";
import VehicleReservationCard from "@/pages/Home/components/VehicleReservationCard";
import useCalendarStore from "@/store/calendarStore";
import type { VehicleReservation } from "@/types/vehicleReservation";

const VehicleDailyReservationList = () => {
  const [date] = useCalendarStore(
    useShallow(state => [state.date]),
  );

  const [dailyReservations, setDailyReservations] = useState<VehicleReservation[]>([]);

  useEffect(() => {
    const loadDaily = async () => {
      const rsvtDt = date.format("YYYYMMDD");
      const data = await fetchVehicleReservationsByDate(rsvtDt);
      setDailyReservations(data);
    };
    loadDaily();
  }, [date]);

  return (
    <div className="flex h-fit max-h-[300px] w-full flex-col items-center justify-start gap-4 overflow-y-auto px-2 py-4">
      <VehicleReservationCard
        key={date.format("MM / DD")}
        date={`${date.format("MM / DD")} (${daysOfTheWeek[date.day()]})`}
        reservationList={dailyReservations}
      />
    </div>
  );
};

export default VehicleDailyReservationList;
